@if (config) {
  <div class="bg-blue-deep px-16px text-black w-full overflow-hidden z-50 relative"
	[ngClass]="{'duration-200': config.allowDismiss, 'h-0 py-0': !active, 'py-12px': active,
	'bg-blue-deep': config.type === 'info',
	'bg-danger': config.type === 'danger',
	'bg-warning': config.type === 'warning',
	'bg-success': config.type === 'success',
	'bg-beige-deep': config.type === 'neutral'
}" role="alert">
    <div class="flex items-center gap-12px">
      <div class="shrink-0 self-baseline">
        @if (!config.icon) {
          <svg class="text-black" width="20" height="20" aria-hidden="true">
            <use xlink:href="#icon-info-sqr-rounded" />
          </svg>
        }
        @if (config.icon) {
          <svg class="text-black" width="20" height="20" aria-hidden="true">
            <use [attr.xlink:href]="'#' + config.icon" />
          </svg>
        }
      </div>
      @if (config.content) {
        <div class="text-14 leading-5" [innerHTML]="config.content"> </div>
      }
      @if (config.action && config.action.url) {
        <a [routerLink]="config.action.url" target="_blank"
          class="banner-action btn-primary-black-xs ml-24px">{{config.action.label}} <span
        aria-hidden="true"></span></a>
      }
      <!-- @if (config.action && config.action.id) { <button (click)="executeAction(config.action.id)"
    class="banner-action btn-primary-black-xs ml-24px">{{config.action.label}} </button> } -->
    @if (config.allowDismiss) {
      <button class="ml-auto text-black hover:text-black/50 active:block/30 btn-icon p-2px self-start" type="button"
        aria-label="Dismiss" (click)="active = false">
        <span class="sr-only">Dismiss</span>
        <svg width="16" height="16">
          <use xlink:href="#icon-banner-close" />
        </svg>
      </button>
    }
  </div>
</div>
}
